<mat-dialog-content>
  <p>Czy na pewno chcesz zablokować klienta? Wszystkie zadania zostaną wstrzymane do momentu odblokowania.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="closeDialog()">Anuluj</button>
  <button matButton cdkFocusInitial (click)="blockClient()">Zablokuj</button>
</mat-dialog-actions>
